export default __webpack_public_path__ + "static/media/logtext.2880903d.png";